// src/components/store/sections/hero-banner/HeroV43TicketvipSunsetAmber.tsx
"use client";

import React from "react";
import DynamicHeroVariant from "./DynamicHeroVariant";

export default function HeroV43TicketvipSunsetAmber(props: any) {
  return (
    <DynamicHeroVariant
      variantNumber={43}
      archKey="ticket_vip"
      archLabel="VIP Boarding Pass Hero"
      palName="SunsetAmber"
      grad="from-amber-500 via-orange-500 to-red-600"
      lightBg="bg-amber-50"
      textCol="text-amber-800"
      borderCol="border-amber-200"
      btnCls="bg-orange-600 hover:bg-orange-700"
      {...props}
    />
  );
}
